import { useCallback, useMemo } from 'react';

import { SHAREABLE_PROFILE_PAGE } from 'src/components/Router';
import type { RouteParams } from 'src/components/Router/generateNavigateTo';
import { useNavigateRoute } from 'src/components/Router/useNavigateRoute';
import { usePage } from 'src/components/Router/usePage';
import { useShareableProfileSlug } from 'src/components/Router/useShareableProfileSlug';

export const useEnterReadMode = () => {
  const navigate = useNavigateRoute();
  const page = usePage();
  const profileSlug = useShareableProfileSlug();

  const routeParams = useMemo(() => {
    const params: RouteParams = {};
    if (page === SHAREABLE_PROFILE_PAGE) {
      params.name = profileSlug;
    }
    return params;
  }, [page, profileSlug]);

  return useCallback(() => {
    navigate(routeParams, { replace: true });
  }, [navigate, routeParams]);
};
